<template>
    <div class="page deliveries-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div v-if="deliveriesMeta">
                    <crud-table :actions="actions" show-search search-placeholder="ابحث باسم منطقة التوصيل" server-pagination :page-count="deliveriesMeta.last_page" :current-page="deliveriesMeta.current_page" :total="deliveriesMeta.total" :per-page="deliveriesMeta.per_page" create-button-text="إضافة منطقة" title="مناطق التوصيل" :items="deliveriesItems" :headers="headers" @load="loadMore" @reset="reset" @create="createDialog = true" @edit="openEditDialog" @delete="openDeleteDialog" @search="searchHandler" />
                </div>
            </transition>

            <action-dialog v-model="createDialog" scrollable max-width="420" vuex-action="createDelivery" success-msg="تم إضافة منطقة التوصيل بنجاح" title="إضافة منطقة توصيل جديدة" subtitle="أدخل بيانات منطقة التوصيل المراد إضافتها" button-text="إضافة" :data="newDelivery" @reset="resetCreateForm">
                <div class="pt-1">
                    <v-text-field v-model="newDelivery.name" label="اسم منطقة التوصيل" placeholder="أدخل اسم منطقة التوصيل" hide-details class="mb-5"></v-text-field>
                    <v-text-field v-model="newDelivery.price" type="number" label="التكلفة" placeholder="أدخل تكلفة التوصيل" hide-details class="mb-5"></v-text-field>
                </div>
            </action-dialog>
            
            <action-dialog v-model="editDialog" scrollable max-width="420" vuex-action="editDelivery" success-msg="تم تعديل منطقة التوصيل بنجاح" title="تعديل منطقة التوصيل" subtitle="تعديل بيانات منطقة التوصيل" button-text="حفظ" :data="{id: editedItem.id, data: {name: editedItem.name, price: editedItem.price}}" @reset="resetEditForm">
                <div class="pt-1">
                    <v-text-field v-model="editedItem.name" label="اسم منطقة التوصيل" placeholder="أدخل اسم منطقة التوصيل" hide-details class="mb-5"></v-text-field>
                    <v-text-field v-model="editedItem.price" type="number" label="التكلفة" placeholder="أدخل تكلفة التوصيل" hide-details class="mb-5"></v-text-field>
                </div>
            </action-dialog>

            <action-dialog v-model="deleteDialog" vuex-action="deleteDelivery" :title="`حذف منطقة التوصيل #${deleteItem ? deleteItem.item_id : ''}`" :data="{id: deleteItem ? deleteItem.id : null}" button-text="تأكيد الحذف" button-color="error">
                هل أنت متأكد من حذف منطقة التوصيل <span class="strong-text--text">"{{deleteItem ? deleteItem.name : ''}}"</span> ؟
            </action-dialog>
            
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CrudTable from '@/components/default/crud-table'

export default {
    name: "Deliveries",
    components: {
        CrudTable
    },
    data(){
        return {
            loading: false,   
            createDialog: false,
            newDelivery: {
                name: '',
                price: '',
            },
            
            editDialog: false,
            editedItem: {
                id: '',
                name: '',
                price: '',
            },
            
            deleteDialog: false,
            deleteItem: null,

            headers: [
                {
                    text: 'إجراءات',
                    align: 'start',
                    sortable: false,
                    value: 'item_id',
                },
                {
                    text: 'منطقة التوصيل',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'التكلفة',
                    align: 'start',
                    sortable: false,
                    value: 'price',
                    money: true,
                },
                /* {
                    text: 'وقت اﻹنشاء',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                }, */
            ],
        }
    },
    computed: {
        ...GlobalComputed,
        deliveries(){
            return this.$store.state.storeModule.deliveries;
        },
        deliveriesMeta(){
            return this.$store.state.storeModule.deliveriesMeta;
        },
        deliveriesItems(){
            return this.deliveries ? this.deliveries.map(delivery=>{
                return {
                    ...delivery,
                    item_id: '',
                };
            }) : [];
        },
        actions(){
            return [
                {name: 'edit', text: 'تعديل', icon: 'mdi-square-edit-outline', color: 'text'},
                {name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'red darken-1'}
            ]
        },
        searchQuery(){
            return this.$route.query.search;
        }
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        searchQuery(query){
            this.loadData();
        }
    },
    methods: {
        ...GlobalMethods,
        resetCreateForm(){
            this.newDelivery = {
                name: ''
            };
        },
        openEditDialog(item){
            Object.assign(this.editedItem, item);
            this.editDialog = true;
        },
        openDeleteDialog(item){
            this.deleteDialog = true;
            this.deleteItem = item;
        },
        loadData(page=1){
            if (!this.loading){
                this.loading = true;
                const query = this.searchQuery || null;
                this.$store.dispatch('getDeliveries', {page, query}).then(response=>{
                    this.loading = false;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل مناطق التوصيل', 'error');
                })
            }
        },
        loadMore(payload){
            this.loadData(payload.page);
        },
        reset(){
            if (this.searchQuery){
                this.$router.replace({query: {}})
            }
            this.loadData();
        },
        resetEditForm(){
            this.editedItem = {
                id: '',
                name: '',
            }
        },
        searchHandler(search){
            this.$router.replace({query: {search}})
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>
